import Vue from "vue";
import api from "../api/index.js";
const Api = new api();
export const change = ({ commit }, item) => {
  commit("CHANGE", item);
};
export const classify = ({ commit }, item) => {
  commit("CLASSIFY", item);
};
export const headerName = ({ commit }, item) => {
  if (!item) {
    commit("HEADERNAME", "医学V视界");
  } else {
    commit("HEADERNAME", item);
  }
};

export const courseVideUrl = ({ commit }, item) => {
  commit("CVU", item);
};
export const wxUserInfoAction = ({ commit }, item) => {
  Api.setStorage("wxUserInfo", item);
  commit("WXUSERINFO", item);
};

export const isLogin = ({ commit }, item) => {
  Api.setStorage("isLogin", item);
  commit("ISLOGIN", item);
};

export const flowerCount = ({ commit }, item) => {
  commit("FLOWERCOUNT", item);
};

export const showCoverAction = ({ commit }, item) => {
  commit("SHOWCOVER", item);
};



// WEBPACK FOOTER //
// ./src/store/actions.js